import axios from 'axios'
import { miniappSkins } from '@/config/miniappSkins'

export const ADMIN_SKIN_SAVED = 'admin-skin-saved'
export function resolveAdminSkin(value: unknown) {
  return miniappSkins.find(skin => skin.value === value) || miniappSkins[0]
}
export function readPublicSkin(data: any, orgId: number): string | undefined {
  if (Number(data?.orgInfo?.id) !== orgId) return undefined
  try {
    const settings = typeof data.orgInfo.settings === 'string' ? JSON.parse(data.orgInfo.settings) : data.orgInfo.settings
    // 2026-10-25：管理端只读取本端配置；尚未拆分的旧机构沿用原皮肤。
    const theme = settings?.adminTheme === undefined ? settings?.miniappTheme : settings.adminTheme
    return miniappSkins.some(skin => skin.value === theme) ? theme : 'classic'
  } catch (_) { return undefined }
}
export function adminSkinRgb(value:unknown):string {
 const hex=String(value || '').replace(/^#/,'')
 const hsl=/^hsl\(\s*([\d.-]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%\s*\)$/i.exec(String(value || ''))
 if(hsl){
  const h=((Number(hsl[1])%360)+360)%360/360,s=Number(hsl[2])/100,l=Number(hsl[3])/100
  if(s<=1 && l<=1){const a=s*Math.min(l,1-l);return [0,8,4].map(n=>{const k=(n+h*12)%12;return Math.round(255*(l-a*Math.max(-1,Math.min(k-3,9-k,1))))}).join(',')}
 }
 if(!/^[0-9a-f]{6}$/i.test(hex))return '24,144,255'
 return [0,2,4].map(index=>parseInt(hex.slice(index,index+2),16)).join(',')
}
let savedSkin: unknown
let activePreview: {owner:symbol;theme:unknown;colors:string[]} | undefined
function paintAdminSkin(value: unknown, colors?:string[]) {
  const preset = resolveAdminSkin(value)
  const skin = {...preset,colors:colors || preset.colors}
  document.documentElement.dataset.adminSkin = skin.value
  document.documentElement.style.setProperty('--activeColorRGB',adminSkinRgb(skin.colors[0]))
  const names = ['--activeColor', '--admin-skin-deep', '--admin-skin-canvas', '--admin-skin-soft', '--admin-skin-surface']
  names.forEach((name, index) => document.documentElement.style.setProperty(name, skin.colors[index]))
  // 仅导航背景加深1.5倍，保留各套皮肤的色相。
  const sidebar = adminSkinRgb(skin.colors[1]).split(',').map(channel => Math.round(Number(channel) / 1.5))
  document.documentElement.style.setProperty('--admin-skin-sidebar', `rgb(${sidebar.join(',')})`)
}
// 编辑期只覆盖当前页面的颜色；公开配置刷新仍记录真实皮肤，离开编辑后恢复。
export function applyAdminSkin(value: unknown) {
  savedSkin=value
  paintAdminSkin(activePreview?.theme ?? value,activePreview?.colors)
}
export function createAdminSkinPreview() {
  const owner=Symbol('admin-skin-preview')
  return {
    update(theme:unknown,colors:string[]) {
      activePreview={owner,theme,colors};paintAdminSkin(theme,colors)
    },
    dispose() {
      if(activePreview?.owner!==owner)return
      activePreview=undefined;paintAdminSkin(savedSkin)
    }
  }
}
// 只读取已有公开皮肤，不调用有编辑权限限制的设置接口，不触发登录拦截器。
export function createAdminSkinSync(load = async (orgId: number) => {
  const result = await axios.get('land/orgidid', { baseURL: process.env.VUE_APP_BASE_API, params: { orgId }, timeout: 8000 })
  if (!result.data?.success) throw new Error('Skin unavailable')
  return result.data.data
}, apply = applyAdminSkin) {
  let generation = 0, currentOrg = 0
  return {
    async refresh(orgId: number) {
      const revision = ++generation
      if (orgId !== currentOrg) { currentOrg = orgId; apply('classic') }
      try {
        const skin = readPublicSkin(await load(orgId), orgId)
        if (revision === generation && skin) apply(skin)
      } catch (_) { /* 同店弱网保留当前皮肤，切店失败使用默认皮肤。 */ }
    },
    dispose() { generation++ }
  }
}
